<template>
    <el-row>
      <el-col :span="12">
        <div v-if="type === '足彩'">
          <el-tabs v-model="cpTypeName" @tab-click="handleClick">
            <el-tab-pane label="胜平负" name="足球胜平负"></el-tab-pane>
            <el-tab-pane label="比分" name="足球比分"></el-tab-pane>
            <el-tab-pane label="总进球数" name="足球总进球数"></el-tab-pane>
            <el-tab-pane label="半全场胜平负" name="足球半全场胜平负"></el-tab-pane>
            <el-tab-pane label="混合过关" name="足球混合过关"></el-tab-pane>
          </el-tabs>
        </div>
        <div v-else-if="type === '篮彩'">
          <el-tabs v-model="cpTypeName" @tab-click="handleClick">
            <el-tab-pane label="胜负" name="篮球胜负"></el-tab-pane>
            <el-tab-pane label="让分胜负" name="篮球让分胜负"></el-tab-pane>
            <el-tab-pane label="胜分差" name="篮球胜分差"></el-tab-pane>
            <el-tab-pane label="大小分" name="篮球大小分"></el-tab-pane>
            <el-tab-pane label="混合过关" name="篮球混合过关"></el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="4">
        <div v-if="isHis">
          <el-date-picker
            v-model="selectDateTime"
            type="date"
            @change="onDateChange"
            placeholder="选择日期时间">
          </el-date-picker>
        </div>
      </el-col>
      <el-col :span="4">
        <div v-if="isHis">
          <el-select v-model="time" placeholder="" @change="handleTimeChange">
            <el-option v-for="item in times" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="2">
        <div v-if="isHis">
          <el-button type="default" @click="btnClick">刷新</el-button>
        </div>
      </el-col>
      <el-col :span="2">
        <div v-if="isHis">
          <el-button type="default" @click="btnEdit">修改</el-button>
        </div>
      </el-col>
    </el-row>
</template>
<script>
export default {
  computed: {
    type () {
      return this.$store.state.type
    },
    isHis () {
      return this.$store.state.isHis
    },
    cpTypeName: {
      get () {
        return this.$store.state.cpTypeName
      },
      set (v) {
        this.$store.state.cpTypeName = v
      }
    }
  },
  data () {
    return {
      time: '11:00',
      times: [{
        value: '11:00',
        label: '10:59'
      }, {
        value: '11:30',
        label: '11:29'
      }, {
        value: '12:00',
        label: '11:59'
      }, {
        value: '12:30',
        label: '12:29'
      }, {
        value: '13:00',
        label: '12:59'
      }, {
        value: '13:30',
        label: '13:29'
      }, {
        value: '14:00',
        label: '13:59'
      }, {
        value: '14:30',
        label: '14:29'
      }, {
        value: '15:00',
        label: '14:59'
      }, {
        value: '15:30',
        label: '15:29'
      }, {
        value: '16:00',
        label: '15:59'
      }, {
        value: '16:30',
        label: '16:29'
      }, {
        value: '17:00',
        label: '16:59'
      }, {
        value: '17:30',
        label: '17:29'
      }, {
        value: '18:00',
        label: '17:59'
      }, {
        value: '18:30',
        label: '18:29'
      }, {
        value: '19:00',
        label: '18:59'
      }, {
        value: '19:30',
        label: '19:29'
      }, {
        value: '20:00',
        label: '19:59'
      }, {
        value: '20:30',
        label: '20:29'
      }, {
        value: '21:00',
        label: '20:59'
      }, {
        value: '21:30',
        label: '21:29'
      }, {
        value: '22:00',
        label: '21:59'
      }, {
        value: '22:30',
        label: '22:29'
      }],
      selectDateTime: new Date()
    }
  },
  methods: {
    addMinutes (time, minutesToAdd) {
      // 将时间字符串转换为 Date 对象
      const [hours, minutes] = time.split(':').map(Number)
      const date = new Date()
      date.setHours(hours)
      date.setMinutes(minutes + minutesToAdd)

      // 格式化回 "HH:mm"
      const newHours = String(date.getHours()).padStart(2, '0')
      const newMinutes = String(date.getMinutes()).padStart(2, '0')

      return `${newHours}:${newMinutes}`
    },
    formatDate (date) {
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0') // 补齐两位
      const day = String(d.getDate()).padStart(2, '0') // 补齐两位
      return `${year}-${month}-${day}`
    },
    onDateChange (value) {
      this.selectDateTime = value
      const format = this.formatDate(value) // 格式化日期为 yyyy-MM-dd
      this.$store.state.start = format + ' ' + this.time
      this.$store.state.end = format + ' ' + this.addMinutes(this.time, 30)
      this.busEmit()
    },
    handleTimeChange (newTime) {
      const format = this.formatDate(this.selectDateTime)
      this.$store.state.start = format + ' ' + newTime // 更新开始时间
      this.$store.state.end = format + ' ' + this.addMinutes(newTime, 30) // 更新结束时间
      // 通过事件总线通知其他组件
      this.busEmit()
    },
    btnClick () {
      const format = this.formatDate(this.selectDateTime)
      this.$store.state.start = format + ' ' + this.time // 更新开始时间
      this.$store.state.end = format + ' ' + this.addMinutes(this.time, 30) // 更新结束时间
      // 通过事件总线通知其他组件
      this.busEmit()
    },
    btnEdit () {
      this.$store.state.edit = !this.$store.state.edit
    },
    busEmit () {
      const start = this.$store.state.start
      const end = this.$store.state.end
      switch (this.cpTypeName) {
        case '足球胜平负': this.$bus.$emit('getDataListFtOne', start, end)
          break
        case '足球比分': this.$bus.$emit('getDataListFtTwo', start, end)
          break
        case '足球总进球数': this.$bus.$emit('getDataListFtThree', start, end)
          break
        case '足球半全场胜平负': this.$bus.$emit('getDataListFtFour', start, end)
          break
        case '足球混合过关': this.$bus.$emit('getDataListFtFive', start, end)
          break
        case '篮球胜负': this.$bus.$emit('getDataListBtOne', start, end)
          break
        case '篮球让分胜负': this.$bus.$emit('getDataListBtTwo', start, end)
          break
        case '篮球胜分差': this.$bus.$emit('getDataListBtThree', start, end)
          break
        case '篮球大小分': this.$bus.$emit('getDataListBtFour', start, end)
          break
        case '篮球混合过关': this.$bus.$emit('getDataListBtFive', start, end)
          break
        default: break
      }
    },
    handleClick (tab, event) {
      this.$store.commit('updateCpTypeName', tab.name)
      const routes = {
        '足球胜平负': '/ft',
        '足球比分': '/ftTwo',
        '足球总进球数': '/ftThree',
        '足球半全场胜平负': '/ftFour',
        '足球混合过关': '/ftFive',
        '篮球胜负': '/bt',
        '篮球让分胜负': '/btTwo',
        '篮球胜分差': '/btThree',
        '篮球大小分': '/btFour',
        '篮球混合过关': '/btFive'
      }
      const routesHis = {
        '足球胜平负': '/ftHis',
        '足球比分': '/ftTwoHis',
        '足球总进球数': '/ftThreeHis',
        '足球半全场胜平负': '/ftFourHis',
        '足球混合过关': '/ftFiveHis',
        '篮球胜负': '/btHis',
        '篮球让分胜负': '/btTwoHis',
        '篮球胜分差': '/btThreeHis',
        '篮球大小分': '/btFourHis',
        '篮球混合过关': '/btFiveHis'
      }
      if (this.isHis) {
        // 如果存在对应路由，则跳转
        if (routesHis[tab.name]) {
          this.$router.push(routesHis[tab.name])
        }
      } else {
        // 如果存在对应路由，则跳转
        if (routes[tab.name]) {
          this.$router.push(routes[tab.name])
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/Top.vue